import { Show, SimpleShowLayout, TextField, DateField, ReferenceField } from 'react-admin';

export const UserShow = () => (
  <Show>
    <SimpleShowLayout>
      <TextField source="id" />
      <TextField source="username" />
      <TextField source="role" />
      <ReferenceField source="groupId" reference="groups" label="Group" emptyText="No Group">
        <TextField source="name" />
      </ReferenceField>
      <DateField source="createdAt" showTime />
      <DateField source="updatedAt" showTime />
    </SimpleShowLayout>
  </Show>
);
